<div *ngIf="columnsConfig">
    <div class="mt-2">
        <kendo-grid [data]="gridView" [loading]="loading" [pageable]="{ buttonCount: 5, pageSizes: pageSizes}"
            [pageSize]="state.take" [skip]="state.skip" [sortable]="true" [sort]="state.sort" [filterable]="false"
            [filter]="state.filter" [groupable]="false" [selectable]="{ mode: 'single' }" [navigable]="true"
            [columnMenu]="false" [resizable]="true" [reorderable]="false" (dataStateChange)="dataStateChange($event)"
            [selectedKeys]="selectedCaseKeys" [selectable]="{ checkboxOnly: true, mode: 'multiple'}"
            [kendoGridSelectBy]="'id'" (selectedKeysChange)="onSelectedKeysChange($event)"
            (save)="consentSaveHandler($event)" (add)="consentAddHandler($event)"
            (cancel)="consentCancelHandler($event)" style="max-height:500px">
            <kendo-grid-messages noRecords="{{ 'NO-CONSENTS' | translate }}"></kendo-grid-messages>
            <kendo-grid-checkbox-column *ngIf="!isReadOnly && revokeAllVisible()" [columnMenu]="false"
                [showSelectAll]="true" [width]="40" class="text-center" headerClass="text-center">
                <ng-template kendoGridHeaderTemplate>
                    <div class="w-100">
                        <input id="selectAllCheckboxId" kendoGridSelectAllCheckbox [state]="selectAllState"
                            (selectAllChange)="onSelectAllChange($event)" type="checkbox" kendoCheckBox>
                        <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-idx="rowIndex" let-dataItem>
                    <input *ngIf="canRevokeConsent(dataItem)" [kendoGridSelectionCheckbox]="idx" type="checkbox"
                        kendoCheckBox />
                </ng-template>
            </kendo-grid-checkbox-column>
            <kendo-grid-column *ngFor="let col of columnsConfig" [field]="col.field" [title]="col.title"
                [width]="col.width" [filterable]="col.filterable" [sortable]="col.sortable" [format]="col.format"
                [hidden]="col.hidden !== undefined ? col.hidden : false"
                [class]="col.class !== undefined ? col.class : ''">
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.dataType === 'boolean'">
                    <div *ngIf="!dataItem.editing" [ngSwitch]="getConsentValue(dataItem, col.field)"
                        [title]="col.title">
                        <div *ngSwitchCase="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                class="bi bi-shield-fill-check" viewBox="0 0 18 18" role="img"
                                attr.aria-label="{{col.title}}">
                                <path fill-rule="evenodd"
                                    d="M8 0c-.69 0-1.843.265-2.928.56-1.11.3-2.229.655-2.887.87a1.54 1.54 0 0 0-1.044 1.262c-.596 4.477.787 7.795 2.465 9.99a11.777 11.777 0 0 0 2.517 2.453c.386.273.744.482 1.048.625.28.132.581.24.829.24s.548-.108.829-.24a7.159 7.159 0 0 0 1.048-.625 11.775 11.775 0 0 0 2.517-2.453c1.678-2.195 3.061-5.513 2.465-9.99a1.541 1.541 0 0 0-1.044-1.263 62.467 62.467 0 0 0-2.887-.87C9.843.266 8.69 0 8 0zm2.146 5.146a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647z" />
                            </svg>
                        </div>
                        <div *ngSwitchCase="false">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                class="bi bi-shield-x" viewBox="0 0 18 18">
                                <path
                                    d="M5.338 1.59a61.44 61.44 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.725 10.725 0 0 0 2.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118a.55.55 0 0 0 .101.025.615.615 0 0 0 .1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533a10.726 10.726 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.775 11.775 0 0 1-2.517 2.453 7.159 7.159 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.158 7.158 0 0 1-1.048-.625 11.777 11.777 0 0 1-2.517-2.453C1.928 10.487.545 7.189 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 62.456 62.456 0 0 1 5.072.56z" />
                                <path
                                    d="M6.146 5.146a.5.5 0 0 1 .708 0L8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 0 1 0-.708z" />
                            </svg>
                        </div>
                        <div *ngSwitchDefault>-</div>
                    </div>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem *ngIf="col.dataType === 'boolean'">
                    <div [formGroup]="consentFormGroup">
                        <input type="checkbox" [formControlName]="col.field" kendoCheckBox [title]="col.title"
                            [indeterminate]="consentFormGroup.get(col.field).value === null"
                            *ngIf="!consentFormGroup.get('type').value || consentFormGroup.get('type').value.code !== 'exclusion'">
                        <div
                            *ngIf="consentFormGroup.get('type').value && consentFormGroup.get('type').value.code === 'exclusion'">
                            <div>-</div>
                        </div>
                    </div>
                </ng-template>
                <!--Type and Assigned By-->
                <ng-template kendoGridCellTemplate let-dataItem
                    *ngIf="col.field === 'type' || col.field === 'signedBy'">
                    <span *ngIf="dataItem[col.field]"
                        [ngClass]="{'consent-exclusion': col.field === 'type' && dataItem[col.field].code === 'exclusion'}"
                        title="{{dataItem[col.field].displayName}}">{{dataItem[col.field].displayName}}</span>
                </ng-template>
                <!--Type-->
                <ng-template kendoGridEditTemplate let-dataItem *ngIf="col.field === 'type'">
                    <div [formGroup]="consentFormGroup">
                        <kendo-combobox [data]="consentTypes" [textField]="'displayName'" [valueField]="'id'"
                            [itemDisabled]="consentTypeItemDisabled" (valueChange)="consentTypeChange()"
                            formControlName="type" attr.aria-label="{{'CONSENT-TYPE' | translate}}">
                        </kendo-combobox>
                    </div>
                </ng-template>
                <!--Signed By-->
                <ng-template kendoGridEditTemplate let-dataItem *ngIf="col.field === 'signedBy'">
                    <div [formGroup]="consentFormGroup">
                        <kendo-combobox [data]="consentSignedBy" [textField]="'displayName'" [valueField]="'id'"
                            formControlName="signedBy" attr.aria-label="{{'SIGNED-BY' | translate}}">
                        </kendo-combobox>
                    </div>
                </ng-template>
                <!--Organization Name-->
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'organizationName'">
                    <span *ngIf="dataItem.organization">{{dataItem.organization.name}}</span>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem *ngIf="col.field === 'organizationName'">
                    <div [formGroup]="consentFormGroup">
                        <kendo-combobox id="organization" formControlName="organization" [data]="organizations"
                            [textField]="'name'" [valueField]="'id'" [itemDisabled]="itemDisabled"
                            (valueChange)="organizationChange()"
                            attr.aria-label="{{'SOURCE-ORGANIZATION' | translate}}">
                        </kendo-combobox>
                    </div>
                </ng-template>
                <!--Signed Date and Expiration Date-->
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.dataType === 'date'">
                    <div class="text-center">{{intl.formatDate(intl.parseDate(dataItem[col.field]), "d")}}</div>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem *ngIf="col.dataType === 'date'">
                    <div [formGroup]="consentFormGroup">
                        <kendo-datepicker *ngIf="col.field === 'signedDate'" class="w-100" formControlName="signedDate"
                            (valueChange)="signedDateChange()" [max]="maxConsentDate">
                        </kendo-datepicker>
                        <kendo-datepicker *ngIf="col.field === 'expirationDate'" class="w-100"
                            formControlName="expirationDate" [min]="consentFormGroup.get('signedDate').value">
                        </kendo-datepicker>
                    </div>
                </ng-template>
                <!-- Consent Status-->
                <ng-template kendoGridCellTemplate let-dataItem *ngIf="col.field === 'consentExpiration'">
                    <div [ngSwitch]="dataItem.revokedDate">
                        <div *ngSwitchCase="null" class="text-center">
                            <span
                                *ngIf="dataItem.memberConsentStatus !== null && dataItem.memberConsentStatus === 'PENDING'"
                                style="color:#b26115;cursor:default;">
                                {{dataItem.memberConsentStatusText}}
                            </span>
                            <span
                                *ngIf="dataItem.memberConsentStatus !== null && dataItem.memberConsentStatus === 'DECLINED'"
                                style="color:#cf4526;cursor:default;">
                                {{dataItem.memberConsentStatusText}}
                            </span>
                            <span
                                *ngIf="dataItem.memberConsentStatus === null && dataItem.consentExpiration !== undefined && dataItem.consentExpiration < 0"
                                style="color:#cf4526">
                                {{'EXPIRED' | translate}}
                            </span>
                            <span
                                *ngIf="dataItem.memberConsentStatus === null && dataItem.consentExpiration !== undefined && dataItem.consentExpiration === '0'"
                                style="color:#cf4526">
                                {{'TODAY' | translate}}
                            </span>
                            <span
                                *ngIf="dataItem.memberConsentStatus === null && dataItem.consentExpiration !== undefined && dataItem.consentExpiration === '1'"
                                style="color:#cf4526">
                                {{dataItem.consentExpiration}} {{'DAY' | translate}}
                            </span>
                            <span
                                *ngIf="dataItem.memberConsentStatus === null && dataItem.consentExpiration !== undefined && dataItem.consentExpiration > 1"
                                [ngStyle]="{'color': consentExpirationColor(dataItem.consentExpiration) }">
                                {{dataItem.consentExpiration}} {{'IN-DAYS' | translate}}
                            </span>
                        </div>
                        <div *ngSwitchDefault class="text-center">
                            <span *ngIf="dataItem.revokedDate" style="color:#cf4526;cursor:default;"
                                title="{{'CONSENT-REVOKED-ON' | translate}}{{dataItem.revokedDate | date: 'MMM d, y, h:mm a'}}">
                                {{'CONSENT-REVOKED' | translate}}
                            </span>
                        </div>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-command-column [width]="60" title="{{ 'ACTIONS' | translate }}" class="text-center"
                *ngIf="!isReadOnly">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <ng-container *ngIf="dataItem.editing">
                        <ng-container *ngIf="consentFormGroup.valid">
                            <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                                (click)="consentSaveButton.click.emit($event);">
                            </i>
                            &nbsp;
                        </ng-container>
                        <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                            (click)="consentCancelButton.click.emit($event); dataItem.editing = false;"></i>
                        <button kendoGridSaveCommand #consentSaveButton class="d-none"></button>
                        <button kendoGridCancelCommand #consentCancelButton class="d-none"></button>
                    </ng-container>
                    <ng-container
                        *ngIf="!dataItem.editing && (deleteExistingConsentAllowed || isPendingConsent(dataItem.id))">
                        <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                            (click)="deleteConsent(dataItem)"></i>
                    </ng-container>
                </ng-template>
            </kendo-grid-command-column>
            <button kendoGridAddCommand #consentAddButton class="d-none"></button>
            <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showConsentDetails">
                <app-document [memberId]="currentMember.id" [memberConsentId]="dataItem.id" [member]="currentMember"
                    [allowAdd]="!isReadOnly && dataItem.consentExpiration >= 0"
                    [allowSendCaptureLink]="!isReadOnly && dataItem.consentExpiration >= 0"
                    [allowSendConsentLink]="!isReadOnly && dataItem.consentExpiration >= 0 && hasConsentTypeAssessment && dataItem.memberConsentStatus !== 'DECLINED'"
                    [allowDelete]="!isReadOnly" (deletedDocument)="documentModified()"
                    (uploadedDocument)="documentModified()">
                </app-document>
            </ng-template>
        </kendo-grid>
    </div>
    <button *ngIf="!isReadOnly" kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3"
        (click)="consentAddButton.click.emit($event);">{{'ADD' | translate}}<i class="far fa-plus"></i>
    </button>
    <button *ngIf="!isReadOnly && revokeAllVisible()" kendoButton [primary]="false" type="button"
        class="float-right mt-3 mb-3 mr-2" (click)="this.open('revokeAll');">{{'CONSENT-REVOKE-ALL' | translate}}
    </button>
    <button *ngIf="!isReadOnly && revokeAllVisible()" kendoButton [primary]="false" type="button"
        class="float-right mt-3 mb-3 mr-2" [disabled]="selectedCaseKeys.length === 0"
        (click)="openRevokeConsentsDialogOpened()">
        {{'REVOKE-CONSENTS' | translate }}<span *ngIf="getSelectedCount() > 0"
            class="ml-1">({{getSelectedCount()}})</span>
    </button>
</div>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="revokeAllOpened" (close)="close('revokeAll')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-REVOKE-ALL' | translate }}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="revokeAllAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="revokeAllAction(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!-- revoke consents dialog -->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="revokeConsentsDialogOpened"
    (close)="cancelRevokeConsents()" [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-REVOKE-SELECTED-CONSENTS' | translate }}</p>
    <kendo-dialog-actions>
        <button kendoButton type="button" (click)="cancelRevokeConsents()">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick kendoButton type="button" (click)="revokeConsents()">
            {{'SAVE' | translate}}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>